import React from "react";
import PropTypes from "prop-types";
import SignupForm from "./signupForm";
import ResponseMessages from "../ResponseMessages";
import { FormattedMessage } from "react-intl";
import PublicLayout from "../../layouts/PublicLayout";

class SignupPanel extends React.Component {
    render() {
        let title = <FormattedMessage id={this.props.panelTitleId} />;

        let footer = (
            <FormattedMessage
                id="login.alreadyHaveAnAccount"
                defaultMessage="Already have an account? {loginLinkText}."
                values={{
                    loginLinkText: (
                        <a href="/login">
                            <FormattedMessage id="login.loginLinkText" defaultMessage="Login now" />
                        </a>
                    ),
                }}
            />
        );

        let view = (
            <SignupForm
                email={this.props.email}
                emailExist={this.props.emailExist}
                domain={this.props.domain}
                password={this.props.password}
                handleFormSubmit={this.props.signupFormSubmit}
                onTextFieldChange={this.props.handleTextFieldChange}
                isLoading={this.props.isLoading}
            />
        );

        let statusMessages = [];
        if (!this.props.isLoading) {
            if (this.props.signupSuccess) {
                view = <FormattedMessage id="signup.signupSuccessPage.panelDescription" />;
                footer = (
                    <FormattedMessage
                        id="signup.signupSuccessPage.emailResendMessage"
                        values={{
                            resendLink: (
                                <a onClick={this.props.handleEmailResend} href="#">
                                    Resend
                                </a>
                            ),
                        }}
                    />
                );
            }

            if (this.props.statusMessages.length > 0) {
                statusMessages = this.props.statusMessages.map((msg, index) => (
                    <ResponseMessages type={msg.type} key={index}>
                        <FormattedMessage id={msg.reason} />
                    </ResponseMessages>
                ));
            }
        }

        return (
            <div className="signupPanel">
                <PublicLayout
                    title={title}
                    content={view}
                    footer={footer}
                    messages={statusMessages}
                />
            </div>
        );
    }
}

SignupPanel.propTypes = {
    password: PropTypes.string,
    email: PropTypes.string,
    emailExist: PropTypes.bool,
    panelTitleId: PropTypes.string,
    statusMessages: PropTypes.array,
    isLoading: PropTypes.bool,
    signupSuccess: PropTypes.bool,
    handleEmailResend: PropTypes.func,
    signupFormSubmit: PropTypes.func,
    handleTextFieldChange: PropTypes.func,
};

export default SignupPanel;
